/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgConnectivity = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M13.707 1.293 20 7.586V2h2v9h-9V9h5.586l-6.293-6.293 1.414-1.414zM2 13h9v2H5.414l6.293 6.293-1.414 1.414L4 16.414V22H2v-9z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgConnectivity as Connectivity };
